
























































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import { objectIsEmpty, isObject } from '@/utils';
import {CreditCard} from '@/components/CreditCard';

@Component({
  name: 'CardPage',
  components: {
    CreditCard,
  },
  props: {
    orderNumber: {
      type: String,
      default: '',
    },
  },
  created() {
    this.getCard(this.orderNumber);
    if (this.$route.query?.order_number) {
      this.$router.push({name: this.$route.name ?? ''});
    }
  },
  data() {
    return {
      tokenData: null,
      cardData: null,
      showPopup: true,
    };
  },
  computed: {
    ...mapGetters('profile', ['creditCardTexts']),
  },
  methods: {
    ...mapActions(['getTokenData', 'sendTokenData']),
    ...mapActions('profile', ['getCardData']),
    isObjectData(obj) {
      return isObject(obj);
    },
    getCard(orderNumber) {
      this.getCardData(orderNumber)
        .then((response) => {
          if (!!response
            && isObject(response.data)
            && !objectIsEmpty(response.data)
            && isObject(response.data.message)
            && !objectIsEmpty(response.data.message)) {
            this.$emit('show:alert', response.data.message);
          } else {
            this.cardData = response.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    sendToPortmone() {
      this.getTokenData('profile/edit/card/')
        .then((response) => {
          this.tokenData = response.form;
          this.$nextTick(() => (this.$refs.submitForm as HTMLElement).click());
        })
        .catch((error) => {
          console.error(error);
        });
    },
    deleteCard() {
      this.$emit('show:deleteCard', () => {
        this.getCard(null);
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.getCard(this.orderNumber);
    next();
  },
})
export default class Title extends Vue {}
